export function extractImagesAndCleanHTML(htmlText: any) {
  if (!htmlText || typeof htmlText !== 'string') {
    return {
      imageUrls: [],
      cleanedHTML: '',
    }
  }

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlText

  let imageUrls: string[] = []

  const imgTags = tempDiv.querySelectorAll('img')
  if (imgTags.length > 0) {
    imageUrls = Array.from(imgTags)
      .map(img => img.src?.trim())
      .filter(src => src && src.startsWith('https://'))

    imgTags.forEach(img => {
      const wrapperDiv = img.closest('div.se-image-container')
      const figure = img.closest('figure')

      if (wrapperDiv) {
        wrapperDiv.remove()
      } else if (figure) {
        figure.remove()
      } else {
        img.remove()
      }
    })
  }

  let cleanedHTML = tempDiv.innerHTML.trim()

  const tempText = cleanedHTML.replace(/\s/g, '')
  if (tempText && !/<[a-z][\s\S]*>/i.test(tempText)) {
    cleanedHTML = `<p>${cleanedHTML}</p>`
  }
  cleanedHTML = cleanedHTML.replace(/<br>/g, '<br/>')
  return {
    imageUrls,
    cleanedHTML,
  }
}
